// extracted by mini-css-extract-plugin
export default {"gallery":"c-q_fW","gallery__header":"c-q_fX","gallery__thumbs":"c-q_fY"};